"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const dynamicLoad_1 = require("../dynamicLoad");
const hooks_1 = require("../hooks");
const featureFlag_1 = require("../featureFlag");
const initializer_1 = require("../initializer");
const translations_1 = require("../translations");
const usd_1 = require("../usd");
const eventBus_1 = require("../eventBus");
const constants_1 = require("./constants");
function MicrofrontendsRoutes({ routes, projectId = constants_1.DEFAULT_PROJECT_ID, DynamicLoadManualStaticImpl, variant = window.COUNTRY, }) {
    const history = (0, react_router_dom_1.useHistory)();
    const { setGlobalLoading } = (0, hooks_1.useGlobalLoading)();
    const DynamicLoadImpl = DynamicLoadManualStaticImpl || new dynamicLoad_1.DynamicLoadManualStatic(variant, projectId);
    const loader = new dynamicLoad_1.DynamicLoadManualManager(DynamicLoadImpl);
    react_1.default.useEffect(() => {
        setGlobalLoading(true);
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Switch, { children: routes.map(c => ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: false, path: `${constants_1.BASE_PATH}${c.route}`, children: (0, jsx_runtime_1.jsx)(dynamicLoad_1.Microfrontend, { id: c.identifier, data: {
                    store: {},
                    externalComponents: {},
                    initializedFeatures: {},
                    history,
                    data: {
                        history,
                        featureFlag: (0, featureFlag_1.getFeatureFlag)(),
                        sessionData: initializer_1.Session.getData(),
                        usd: (0, usd_1.getData)(),
                        eventBus: (0, eventBus_1.getGlobalEventBus)(),
                        cacheData: initializer_1.GlobalCache?.getInitialData(),
                        translations: {
                            web: (0, translations_1.getTranslationsLoaded)().entries,
                            config: (0, translations_1.getConfigTranslationsLoaded)().entries,
                        },
                    },
                }, loader: loader, onLoad: () => setGlobalLoading(false) }) }, c.identifier))) }));
}
exports.default = MicrofrontendsRoutes;
//# sourceMappingURL=MicrofrontendsRoutes.js.map